import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
curretnYear:number=0;
constructor(){
  this.curretnYear = new Date().getFullYear();
}
}
